import usePostData from '../../../../../hooks/postHook';

export const useCreateProduct = ({ id }) => {
  const [{ data, isLoading, isError, error }, createProduct] = usePostData(
    `office_parcel/${id}/cases`
  );

  return { data, isLoading, isError, error, createProduct };
};
